import * as React from 'react';
import { Modal, ModalBody, Button, ModalHeader } from '@msdyn365-commerce-modules/utilities';

export interface IConfirmationDialogModalProps {
    isOpen: boolean;
    headerLabel: string;
    message: string;
    confirmLabel: string;
    cancelLabel: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmationDialogModal: React.FC<IConfirmationDialogModalProps> = ({
    isOpen,
    headerLabel,
    message,
    confirmLabel,
    cancelLabel,
    onConfirm,
    onCancel
}) => (
    <div>
        <Modal isOpen={isOpen} className='confirm-dialog-modal' contentClassName='confirm-dialog-modal__content'>
            <ModalHeader>
                <p>{headerLabel}</p>
            </ModalHeader>
            <ModalBody>
                <p>{message}</p>
                <div className='button-group'>
                    <Button className='primary' onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                    <Button className='secondary' onClick={onCancel}>
                        {cancelLabel}
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    </div>
);

export default ConfirmationDialogModal;
